import type { PaletteItem } from "@nexxt/ui";
import { useEffect } from "react";

// Actions of the screen on display, offered by ⌘K (design-system.md §4.10). A registry read when the palette opens,
// not React state: a screen re-registering on every render causes no re-render.

const registry = new Map<symbol, PaletteItem[]>();

export function usePaletteActions(items: PaletteItem[]): void {
  useEffect(() => {
    const key = Symbol();
    registry.set(key, items);
    return () => {
      registry.delete(key);
    };
  }, [items]);
}

export const screenActions = (): PaletteItem[] => [...registry.values()].flat();
